import React from "react";

import styles from "./FilterCheckbox.module.scss";

interface FilterCheckboxProps {
  labelText: string;
  color?: string;
  id: string;
}

const FilterCheckbox: React.FC<FilterCheckboxProps> = ({ id, labelText, color }) => {
  const [isChecked, setIsChecked] = React.useState(false);

  return (
    <div className={styles.checkbox}>
      <input type="checkbox" id={id} onChange={() => setIsChecked(!isChecked)} />
      <label htmlFor={id}>
        {color?.length && <div className={styles.square} style={{ background: color }} />}
        {labelText}
      </label>
    </div>
  );
};

export default FilterCheckbox;
